import { SCREEN_PRESENTER } from '@studio/constants/Sources';
import { decreaseScreenShare } from '@shoflo/studio-redux/actions/screenShare/setScreenShare';
import removePresenter from 'actions/source/removePresenter';

async function agoraScreenShareStopped({ getState, dispatch }, { attendeeId }) {
  const { broadcastSources } = getState();

  const source = broadcastSources?.sources?.find(s => s.value === attendeeId);

  if (source) {
    dispatch(removePresenter(attendeeId));

    if (source.type === SCREEN_PRESENTER) {
      dispatch(decreaseScreenShare());
    }
  } else {
    // Even if source doesn't exist (e.g., user cancelled from browser picker),
    // we still need to decrement the screen share count.
    // The count was incremented when director approved the request,
    // but source was never created because presenter cancelled.
    dispatch(decreaseScreenShare());
  }
}

export default agoraScreenShareStopped;
